module.exports = __webpack_public_path__ + "3aee9121ed836dcab7356ea55a91cacf.png";